export const mapDataToClient = (device) => ({
  id: device.id,
  name: device.name,
  address: device.address,
  type: device.typename,
  key: device.id,
  text: device.name,
  value: device.id,
});
